export const style = {
  wrapper: {
    padding: `0 25`
  },
  box: {
    padding: `20px`,
    border: `1px solid #666`,
    borderRadius: `3px`
  },
  listBox: {
    paddingLeft: `25px`
  },
  row: {
    padding: 0,
    ':not(:last-of-type)': {
      borderBottom: `1px solid #666`
    }
  },
  label: {
    color: `black`,
    fontSize: `15px`,
    paddingTop: `6px`
  },
  value: {
    fontSize: `15px`,
    fontWeight: 500,
    lineHeight: `35px`,
    alignText: `right`
  },
  firstlabel: {
    color: `#A94545`,
    fontWeight: 600
  },
  firstValue: {
    color: `#A94545`,
    fontWeight: 600
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/style/ColorBlind/topgeo.js